<template>
  <div id="home-page" class="container">
    <div class="title">产品反馈</div>
    <div class="form-container">
      <label for="internal_goods_no" class="form-label">小着编码</label>
      <input type="text" id="internal_goods_no" v-model="form.internal_goods_no" class="form-input small-input">
      <label for="desc" class="form-label">反馈信息</label>
      <textarea id="desc" v-model="form.desc" class="form-textarea"></textarea>
      <label for="nickname" class="form-label">创建者</label>
      <input type="text" id="nickname" v-model="form.nickname" class="form-input small-input">
      <label for="shop" class="form-label">选择店铺</label>
      <select id="shop" v-model="form.shop_id" class="form-select small-input">
        <option value="2002">武康路店</option>
        <option value="2003">巨鹿路店</option>
        <option value="5001">天猫店</option>
        <option value="6001">抖店店</option>
      </select>
      <div>
        <div class="button-container">
          <button class="upload-button" @click="openFileInput">上传图片</button>
        </div>
        <!-- 文件上传输入字段 -->
        <input type="file" accept="image/*" ref="fileInput" @change="uploadImages" multiple style="display: none">
      </div>
      <div class="image-list">
        <div v-for="(image, index) in selectedImages" :key="index" class="image-item">
          <img :src="image" alt="Selected Image" width="100" height="150">
        </div>
      </div>
      <button @click="submit" class="form-button">提交</button>
    </div>
    <!-- Success Dialog -->
    <!-- Success Dialog with Fade Transition -->
    <transition name="fade">
      <div v-if="isDialogVisible" class="success-dialog">
        <div class="success-content">
          <h2>{{ dialogMsg }}</h2>
          <button class="form-button" @click="closeDialog">关闭</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios' // 引入axios
import { createGoodsFeedback } from '@/api/applyVip'

export default {
  data() {
    return {
      form: {
        internal_goods_no: '',
        desc: '',
        nickname: '',
        shop_id: '2002', // 设置默认店铺
      },
      selectedImages: [], // 维护已选择的图片列表
      isDialogVisible: false, // 控制成功对话框的显示
      dialogMsg: '',
    }
  },
  methods: {
    async submit() {
      if (!this.form.internal_goods_no || !this.form.desc || !this.form.nickname || !this.form.shop_id) {
        this.showDialog('请完整填写内容。')
        return
      }
      try {
        // 提交表单数据
        console.log('this.form', this.form)
        const feedbackResponse = await createGoodsFeedback(this.form)
        if (feedbackResponse.data) {
          // 上传成功后显示成功对话框
          this.showDialog('反馈成功')
        } else {
          this.showDialog('提交失败，请重试')
        }
      } catch (error) {
        this.showDialog('出了点问题，请刷新重试')
      }
    },
    openFileInput() {
      this.$refs.fileInput.click()
    },
    async uploadImages() {
      // const input = this.$refs.imageInput
      const input = event.target // 获取触发事件的输入字段
      console.log('input.files', input.files)
      if (input.files.length === 0) {
        return
      }
      try {
        for (let i = 0; i < input.files.length; i++) {
          const imageUrl = URL.createObjectURL(input.files[i])
          this.selectedImages.push(imageUrl)
          const formData = new FormData()
          formData.append('file', input.files[i], '.png');
          await this.updateImage(formData)
        }
        this.$refs.fileInput.value = '';
      } catch (error) {
        console.error(error)
        this.showDialog('图片上传失败')
      }
    },
    showDialog(msg) {
      this.dialogMsg = msg
      this.isDialogVisible = true
    },
    closeDialog() {
      this.isDialogVisible = false
      this.dialogMsg = ''
    },
    async updateImage(formData) {
      const response = await axios.post('https://v.axiaozhuo.com/xz/api/v1/image/upload_file?sign_verify=do_not_verify', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      if (response.error_code === 0) {
        // 上传成功
        const uploadedImageId = response.data.image_id
        // 如果 form.images 还没有值，直接将 uploadedImageId 赋值给它
        if (!this.form.images) {
          this.form.images = uploadedImageId
        } else {
          // 否则，将 uploadedImageId 追加到现有的 form.images，用逗号分隔
          this.form.images += ',' + uploadedImageId
        }
        console.log('this.form.images', this.form.images)
      } else {
        // 上传失败，可以在这里进行错误处理
        this.showDialog('图片上传失败')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
    font-family: Arial, sans-serif;
    padding: 70px;
    max-width: 300px;
    margin: 0 auto;
}
.small-input {
    width: 50%; /* 设置宽度为原来的一半 */
}
.form-container {
    display: flex;
    flex-direction: column;
}

.title {
  margin-bottom: 40px;
  font-weight: bold;
  text-align: center;
}

.form-label {
    margin-bottom: 10px;
}

.form-input,
.form-textarea,
.form-select {
    width: 100%;
    margin-bottom: 20px;
    padding: 10px;
    font-size: 16px;
    border-radius: 5px;
    border: 1px solid;
}

.form-textarea {
    height: 80px;
}

.form-button {
    padding: 10px 20px;
    font-size: 16px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.success-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}

.success-content {
    //width: 80px;
    //height: 30px;
    background: white;
    padding: 20px;
    border-radius: 5px;
    text-align: center;
    //box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    max-width: 90%; /* Adjust the maximum width as needed for mobile devices */

}

.success-content.button {
    margin-top: 10px;
    padding: 5px 10px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
select, select option {
  color: black;
  -webkit-text-fill-color: black; /* 主要为iOS设备 */
}
input, select, textarea {
  width: 200px;  /* or any width you prefer */
  border: 1px solid #ccc;
  padding: 4px 8px;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
  font-size: 14px;
}
.image-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between
}

.image-item {
  margin: 5px;
}
.button-container {
  display: flex;
  justify-content: space-around;
  margin: 20px;
}

.upload-button {
  background-color: #0074D9;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.camera-button {
  background-color: #0074D9;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
